const url = 'https://us-central1-bookstore-api-e63c8.cloudfunctions.net/bookstoreApi/apps/Rj9RGwY9Ge0xtfuHmKXK/books';

export default url;
